import { v4 as uuidv4 } from "uuid";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import { createImageBlock } from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/mediaBlockHelpers";
import {
  createBadgeListBlock,
  createH2Block,
  createH3Block,
  createPBlock,
} from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/textBlocksHelpers";
import { getBorderRadiusOptions } from "@circle-react-shared/BuilderUI/utils/imgStyleHelpers";
import { getSizingOptions } from "@circle-react-shared/BuilderUI/utils/sizeStyleHelpers";
import { getSalesBlockPrimaryStyleOptions } from "../constants";
import imagePlaceholder from "./block_image_placeholder.png";

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "SalesBlock3",
  meta: {},
  props: {
    leftContent: {
      meta: {
        name: "Left Content",
        nameI18n: "builder_ui.prop_type.left_content",
      },
      prop: "children",
      type: "children",
      value: [
        createImageBlock({
          signedId: "",
          placeholder: imagePlaceholder,
          styles: {
            sizing: getSizingOptions({
              defaultValue: {
                maxWidth: "none",
                maxHeight: "none",
                width: "100%",
                height: "100%",
                minWidth: "none",
                minHeight: "none",
              },
            }),
            borderRadius: getBorderRadiusOptions({
              defaultValue: {
                border_left_top_radius: 20,
                border_left_bottom_radius: 20,
                border_right_top_radius: 20,
                border_right_bottom_radius: 20,
              },
            }),
          },
        }),
      ],
    },
    header: {
      meta: {
        name: "Header",
        nameI18n: "builder_ui.prop_type.header",
      },
      prop: "children",
      type: "children",
      value: [
        createH2Block({
          text: "Meet Your Coach",
        }),
      ],
    },
    user: {
      meta: {
        name: "User",
        nameI18n: "builder_ui.prop_type.user",
      },
      prop: "children",
      type: "children",
      value: [
        createH3Block({
          text: "Sarah Johnson",
        }),
        createPBlock({
          text: "Certified Professional Coach, MBA, Former Fortune 500 Executive",
          paragraphStyle: "p3",
        }),
      ],
    },
    description: {
      meta: {
        name: "Description",
        nameI18n: "builder_ui.prop_type.description",
      },
      prop: "children",
      type: "children",
      value: [
        createPBlock({
          text: "With over 15 years of experience in leadership development and personal transformation, I've guided hundreds of professionals from feeling stuck to achieving breakthrough results.",
        }),
        createPBlock({
          text: "After climbing the corporate ladder and reaching what I thought was 'success,' I realized something was missing. This led me on a journey of self-discovery that transformed my approach to achievement, fulfilment, and purpose.",
        }),
        createPBlock({
          text: "Today, I combine my corporate expertise with deep coaching methodologies to help ambitious professionals create success on their own terms—without the burnout, overwhelm, or sacrifice.",
        }),
      ],
    },
    badges: {
      meta: {
        name: "Badges",
        nameI18n: "builder_ui.prop_type.badges",
      },
      prop: "children",
      type: "children",
      value: [
        createBadgeListBlock({
          items: [
            "Certified Professional Coach (ICF)",
            "MBA from Harvard Business School",
            "Former Executive at Fortune 500 Companies",
            "Author of: Authentic Success",
            "Featured in Forbes & Inc.",
          ],
        }),
      ],
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        ...getSalesBlockPrimaryStyleOptions(),
      },
      meta: {
        name: "Styles",
        nameI18n: "builder_ui.prop_type.styles",
        category: [],
      },
    },
  },
};
